import {
  FETCH_PERMISSION_FAILURE,
  FETCH_PERMISSION_LOADING,
  FETCH_PERMISSION_SUCCESS,
  UPDATE_PERMISSION_FAILURE,
  UPDATE_PERMISSION_LOADING,
  UPDATE_PERMISSION_SUCCESS
} from '../Types/userPermissionsTypes copy';
import api from '../config/api';

const API_URL = process.env.REACT_APP_TRAVEL_URI;

export const getUserPermmissions = () => {
  return dispatch => {
    dispatch({
      type: FETCH_PERMISSION_LOADING
    });
    api
      .get(`${API_URL}Privilege/search`)
      .then(response => {
        const data = response.data.data;
        dispatch(fetchPermissionSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchPermissionError(errorMsg));
      });
  };
};

export const getPermmissionsByUser = id => {
  return dispatch => {
    dispatch({
      type: FETCH_PERMISSION_LOADING
    });
    api
      .get(`${API_URL}Privilege/search/${id}`)
      .then(response => {
        const data = response.data.data;
        dispatch(fetchPermissionSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchPermissionError(errorMsg));
      });
  };
};

export const fetchPermissionSuccess = data => {
  return {
    type: FETCH_PERMISSION_SUCCESS,
    payload: data
  };
};

export const fetchPermissionError = error => {
  return {
    type: FETCH_PERMISSION_FAILURE,
    payload: error
  };
};

export const UpdatePermissionsByUser = (id, data) => {
  return dispatch => {
    dispatch({
      type: UPDATE_PERMISSION_LOADING
    });
    api
      .put(`${API_URL}Privilege/update/${id}`, data)
      .then(async () => {
        await dispatch({
          type: UPDATE_PERMISSION_SUCCESS
        });
        await dispatch(getPermmissionsByUser(id));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: UPDATE_PERMISSION_FAILURE,
          payload: errorMsg
        });
      });
  };
};
